/**
 * created by xcc
 ViewContentText 查看上下文
 *
 */
import React, {Component} from 'react';
import {Modal} from "antd";
import $jq from "jquery";
import {checkWordReplace} from "./contentView/htmlFormat";

export default class ViewContentText extends Component {
    static defaultProps = {
        title: "所在句子"
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            dataItem: {},
        }
    }

    show(record) {
        this.setState({
            visible: true,
            dataItem: record,
        })
    }

    onCancel = () => {
        // this.hoverText = this.onOnce()
        this.setState({
            visible: false
        })
    };

    setCheckWord = (item) => {
        if (!item || typeof item.word === 'undefined' || typeof item.sentence === 'undefined') {
            return <span>数据加载失败或数据不完整</span>;
        }
        let itemWord = item?.word;//错误词
        let itemCorrectWord = item.correct;//正确词
        let currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
        let replaceHtml = '<span  class="itemWord_newMedia currentWord_newMedia" check="' + currWord + '">' + itemWord + '</span>';
        let content = checkWordReplace(item.sentence, itemWord, replaceHtml)
        return <div style={{wordBreak: "break-word"}} dangerouslySetInnerHTML={{__html: content}}></div>;
    };

    onOnce = () => {
        let that = this;
        let flag = false;
        return function () {
            if (!flag) {
                flag = true;
                that.hoverText && that.hoverText()
            }
        }
    }

    hoverTextFun = this.onOnce()

    /**
     * 添加敏感词鼠标悬浮效果
     */
    time = 0;
    throttle = (call) => {
        setTimeout(() => {
            call && call()
        }, 100)
    };
    hoverText = () => {
        let viewContentText = $jq(".viewContentText");
        viewContentText.on('mouseover', ".currentWord_newMedia", (e) => {
            console.log("'mouseenter'");
            this.throttle(() => {
                this.enter(e)
            });
        });
        viewContentText.on('mousemove', ".currentWord_newMedia", (e) => {
            console.log("mousemove");
            this.throttle(() => {
                this.move(e)
            });
        });
        viewContentText.on('mouseout', ".currentWord_newMedia,.correctWord", (e) => {
            console.log("mouseout");
            this.throttle(() => {
                this.out(e)
            });
        });
        viewContentText.on('mouseleave ', ".currentWord_newMedia,.correctWord", (e) => {
            console.log("mouseleave");
            this.throttle(() => {
                this.out(e)
            });
        });
    };

    move = (e) => {
        e.preventDefault();
        let dom = $jq(".correctWord");
        if (dom?.length) {
            let clientX = e.clientX;
            let clientY = e.clientY;
            dom.css("left", clientX);
            dom.css("top", clientY)
        } else {
            this.enter(e)
        }
    };

    enter = (e) => {
        e.preventDefault();
        let clientX = e.clientX - 2;
        let clientY = e.clientY + 2;
        var currWord = e.target.attributes.check.value;
        $jq('.correctWord').remove();
        let dome = '<span style="left:' + clientX + 'px;top:' + clientY + 'px  " class="correctWord">' +
            '<span></span>' +
            '<span>' + currWord + '</span>' +
            '</span>';
        $jq(".viewContentText").append(dome);
    };

    out = (e) => {
        e.preventDefault();
        $jq('.correctWord').remove()
    };

    render() {
        let {dataItem} = this.state;
        const {title} = this.props;
        return (
            <Modal
                visible={this.state.visible}
                title={title}
                onCancel={this.onCancel}
                cancelText={"关闭"}
                okButtonProps={{
                    style: {display: "none"}
                }}
                maskClosable={false}
                centered
            >
                <div className={"viewContentText"} onMouseEnter={this.hoverTextFun}>
                    {this.setCheckWord(dataItem)}
                </div>
            </Modal>
        )
    }

}